<template>
  <section class="pd-y-30" style="background: #F7FAFF">
    <!-- <div class="container" style="max-width: 600px !important">
      <div class="section-title">
        <h2>{{ comp.task }}</h2>
        <p>{{ comp.f1 }}</p>
      </div>
    </div> -->
    <div class="container">
      <div class="row">
        <!-- 35572 -->
        <div
          :class="`${t.st3=='card-row-full'?'col-12':'col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4'}`"
          v-for="(t, i) in tasks"
          :key="i"
        >
          <div v-if="t.st3=='card-row-full'" class="">
            <div class="row no-gutters">
              <!-- <div class="col-3">
                <img :src="`${t.defaultAttachmentUrl}?w=600`" class="wd-100p" />
              </div> -->
              <div class="col-12">
                <div v-html="t.taskDesc"></div>
              </div>
            </div>
            <div class="section-title mg-y-30 pd-y-30 bg-white">
              <h2>{{ comp.task }}</h2>
              <p>{{ comp.f1 }}</p>
            </div>
          </div>
          <div v-else class="card">
            
            <router-link
              :to="{
                name: $store.state.app.activeGroup.publicPage.route,
                params: {
                  id: $store.state.app.contentPageId,
                  cid: t.id
                }
              }"
            >
              <img
                :src="`${t.defaultAttachmentUrl}?w=460&h=240&mode=pad`"
                class="card-img wd-100p"
              />
              <div class="card-body">
                <h5 class="card-title text-truncate">{{ t.task }}</h5>
                <div class="text-orange">
                  {{ t.createdDate | moment("YYYY.MM.DD") }}
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { request } from "@/api/all";

export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tasks: []
    };
  },
  mounted() {
    this.loadTasks(this.comp.locTypeId1);
  },
  methods: {
    loadTasks(typeId) {
      //console.log('=>', this.comp);
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 100,
          ot: 357,
          model: {
            isPublic: true,
            locTypeId1: typeId
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.tasks = res.data.tasks;
        }
      });
    }
  }
};
</script>

<style></style>
